import script from "./TextClamp.vue?vue&type=script&setup=true&lang=js"
export * from "./TextClamp.vue?vue&type=script&setup=true&lang=js"

import "./TextClamp.vue?vue&type=style&index=0&id=385e3055&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-385e3055"]])

export default __exports__